import React, { useState } from "react";
import { UploadCloud, Loader2, CheckCircle2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuthImage } from "@/components/common";

export default function Uploader({ onUploaded, fileId, testid = "file-uploader", label = "Upload screenshot" }) {
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error("File too large (max 5MB)"); return; }
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/files", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.file_id);
      toast.success("Uploaded");
    } catch (e) { toast.error(errMsg(e)); } finally { setUploading(false); }
  };

  if (fileId) {
    return (
      <div className="relative inline-block">
        <AuthImage fileId={fileId} className="w-full max-h-56 object-contain rounded-xl border border-slate-200 bg-slate-50" />
        <button type="button" onClick={() => onUploaded(null)} data-testid={`${testid}-clear`}
          className="absolute top-2 right-2 bg-white rounded-full p-1.5 shadow border border-slate-200 hover:bg-slate-50">
          <X className="w-4 h-4 text-slate-600" />
        </button>
        <div className="absolute bottom-2 left-2 inline-flex items-center gap-1 bg-emerald-600 text-white text-xs px-2 py-1 rounded-full">
          <CheckCircle2 className="w-3 h-3" /> Attached
        </div>
      </div>
    );
  }

  return (
    <label className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-slate-300 rounded-xl p-6 cursor-pointer hover:border-blue-400 hover:bg-blue-50/40 transition"
      data-testid={testid}>
      {uploading ? <Loader2 className="w-7 h-7 text-blue-600 animate-spin" /> : <UploadCloud className="w-7 h-7 text-slate-400" />}
      <span className="text-sm font-medium text-slate-600">{uploading ? "Uploading..." : label}</span>
      <span className="text-xs text-slate-400">JPG, PNG or WEBP · max 5MB</span>
      <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={handle} disabled={uploading} />
    </label>
  );
}
